import Cookies from 'js-cookie';
import { LANGUAGE_KEY } from '../constants';

export const getLanguageCookie = () => {
  return Cookies.get(LANGUAGE_KEY) as string | undefined;
};

export const setLanguageCookie = (language: string) => {
  Cookies.set(LANGUAGE_KEY, language);
};

export const normalizeLanguageCode = (code: string): string => {
  const lower = code.toLowerCase();
  if (lower.startsWith('zh'))
    return lower.includes('tw') || lower.includes('hk') || lower.includes('mo') ? 'zh-TW' : 'zh-CN';
  switch (lower.split('-')[0]) {
    case 'zh':
      return 'zh-CN';
    case 'tl':
      return 'fil';
    case 'iw':
      return 'he';
    case 'jw':
      return 'jv';
    default:
      return lower.split('-')[0];
  }
};

export const detectBrowserLanguage = (): string => {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const list: string[] = [];
  if (nav && typeof (nav as Navigator).language === 'string') list.push((nav as Navigator).language);
  if (nav && Array.isArray((nav as Navigator).languages)) list.push(...((nav as Navigator).languages as string[]));
  for (const cand of Array.from(new Set(list))) {
    return normalizeLanguageCode(String(cand));
  }
  return 'en';
};
